const TRUMPS = ['C', 'D', 'H', 'S', 'NT'];

/**
 * A Trick can contain up to 4 cards, and has a winningCard
 * @param  {String} trumpSuit - the tump suit - C, D, H, S, NT
 * @param  {Card[]} cards - optional list of cards to populate trick with
 */
class Trick {
	constructor(trumpSuit, cards = []) {
		this._trumpSuit = null;
		this._cards = [];
		this.setTrumpSuit(trumpSuit);
		this.addCards(cards);

		this.trickSuit = null;
	}

	setTrumpSuit(trumpSuit) {
		if (!TRUMPS.includes(trumpSuit)) {
			throw new Error('Invalid trump suit');
		}
		this._trumpSuit = trumpSuit;
	}

	/**
	 * @private
	 * @param {Card[]} adds a list of cards to the trick
	 */
	addCards(cards) {
		for (let card of cards) {
			this.addCard(card);
		}
	}

	/**
	 * @param {Card} card adds a card to the trick
	 */
	addCard(card) {
		if (this.trickSuit == null) {
			this.trickSuit = card.suit;
		}
		// TODO: reject invalid card?
		if (this._cards.length >= 4) {
			throw new Error('Too many cards for trick');
		}

		// set state of card
		card.state = 'inplay';

		this._cards.push(card);
		this.updateWinner(card);
		this.updateCardStatuses();
	}

	/**
	 * @return {Card[]} list of cards in this trick
	 */
	get cards() {
		return this._cards;
	}

	/**
	 * If the trick is complete, then update the card status to played
	 * @private
	 * @return {[type]} [description]
	 */
	updateCardStatuses() {
		if (this.isComplete) {
			for (let card of this._cards) {
				card.state = 'played';
			}
		}
	}

	/**
	 * Updates the current winning card if new card beats the current winner. first card is always the winner
	 * @param  {Card} card the card to compare with
	 * @return {Card} the current winning card
	 * @private
	 */
	updateWinner(card) {
		// no winner set
		if (!this.winner) {
			this.winner = card;
			return this.winner;
		}

		// check for trumps
		if (card.suit.short === this.trumpSuit) {
			// trumps always win over non-trumps
			if (this.winner.suit != card.suit) {
				this.winner = card;
			}
		}

		// same suit - compare on rank
		if (card.suit === this.winner.suit) {
			if (card.isHigherThan(this.winner)) {
				this.winner = card;
			}
		}
		return this.winner;
	}

	/**
	 * @return {String} the trump suit for the trick
	 */
	get trumpSuit() {
		return this._trumpSuit;
	}

	/**
	 * @return {Card} the current winning card
	 */
	get winningCard() {
		return this.winner;
	}

	get winningPair() {
		// no winner until trick complete
		return this.isComplete ? this.winningCard.player.seat.pair : null;
	}

	get isComplete() {
		return this.cards.length == 4;
	}
}

module.exports = Trick;
